import { useQuery } from "@tanstack/react-query"

import * as actions from '@/actions';
import { slugFromLabel } from '@/lib/tour-slug';
import { TActivity, TLocation, TSelectOption } from "@/types";
import { allActivitiesOption, allLocationsOption } from "../Search";

const fallbackData: Array<TSelectOption> = [];

const formatOptions = (data: TActivity[] | TLocation[], query: 'activities' | 'locations') => {
  const transformedData = data.map(
    (item) =>
      ({
        label: item.name,
        value: item.id,
        slug: item.slug ?? slugFromLabel(item.name),
      }) as TSelectOption,
  );
  const defaultOption = query === 'activities' ? allActivitiesOption : allLocationsOption;
  return [defaultOption, ...transformedData];
}

export const useSearchQuery = ({ activity = 0, location = 0 }) => {
  const { data: allActivities = fallbackData, isLoading: isLoadingAllActivities } = useQuery({
    queryKey: ['allActivities'],
    queryFn: () => actions.fetchActivitiesList(0),
    select: (data) => formatOptions(data, 'activities'),
  });

  const { data: locations = fallbackData, isLoading: isLoadingLocations } = useQuery({
    queryKey: ['locations', activity],
    queryFn: () => actions.fetchLocationsList(activity),
    select: (data) => formatOptions(data, 'locations'),
  });

  const { data: activities = fallbackData, isLoading: isLoadingActivities } = useQuery({ 
    queryKey: ['activities', location],
    queryFn: () => actions.fetchActivitiesList(location),
    select: (data) => formatOptions(data, 'activities'),
  });

  return { activities, locations, isLoadingActivities, isLoadingLocations, allActivities, isLoadingAllActivities };
}